// extracted by mini-css-extract-plugin
module.exports = {"announcementContainer":"_040e9db","date":"_8d94671","username":"_20d0262","announcement":"_314b8de","announcementInfo":"_a2deaba"};